import React from 'react';
import { Link } from 'react-router-dom';

const GizlilikPolitikasi: React.FC = () => {
  return (
    <div className="page-content">
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Gizlilik Politikası
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Motopack web sitesinin gizlilik politikası ve çerez kullanımı hakkında bilgiler.
          </p>
        </div>
      </section>
      <section className="about-content" style={{ background: 'var(--bg-primary)', paddingTop: '2.5rem', paddingBottom: '2.5rem' }}>
        <div className="container">
          <div style={{ background: 'var(--primary-lightest)', borderRadius: '12px', padding: '1.1rem 1.2rem', marginBottom: '1.2rem', color: 'var(--primary-dark)', fontWeight: 600, fontSize: '1.05rem', boxShadow: '0 2px 8px 0 rgba(0,102,204,0.07)', textAlign: 'center' }}>
            Motopack olarak ziyaretçilerimizin gizliliğine önem veriyoruz. Sitemizi kullanarak çerez politikamızı ve gizlilik esaslarımızı kabul etmiş olursunuz.
          </div>
          <h2 style={{ fontWeight: 700, fontSize: '1.3rem', color: 'var(--primary-color)', marginBottom: '1.2rem' }}>Gizlilik Politikası</h2>
          <div style={{ color: 'var(--text-secondary)', fontSize: '1rem', marginBottom: '1.2rem', lineHeight: 1.7 }}>
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>I. Giriş</h3>
            Motopack Lojistik ve Teknoloji A.Ş. (“Motopack” veya “Şirket”), kişisel bilgilerinizi korumaya büyük bir önem vermektedir. Bu Gizlilik Politikası, internet sitemizi ve dijital platformlarımızı kullandığınızda, kişisel verilerinizin nasıl toplandığını, kullanıldığını, saklandığını ve korunduğunu açıklamak amacıyla hazırlanmıştır.<br />
            Motopack, Kişisel Verilerin Korunması Kanunu (KVKK) başta olmak üzere, kişisel verilerin korunmasına ilişkin tüm mevzuat hükümlerine uygun hareket etmektedir. Bu politikada yer alan tüm açıklamalar, kişisel verilerinizin nasıl güvenli bir şekilde işlendiğini ve korunduğunu anlamanıza yardımcı olacaktır.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>II. Toplanan Kişisel Veriler</h3>
            Motopack, internet sitemizi ziyaret ettiğinizde, dijital platformlarımıza erişim sağladığınızda ve çeşitli hizmetlerimizden yararlandığınızda, aşağıdaki kişisel verileri toplayabilir:<br />
            <b>Kimlik Bilgileri:</b> Ad, soyad, unvan<br />
            <b>İletişim Bilgileri:</b> E-posta adresi, telefon numarası, posta adresi<br />
            <b>Ödeme Bilgileri:</b> Fatura adresi, ödeme yöntemleri, ödeme geçmişi<br />
            <b>Teknik Veriler:</b> IP adresi, cihaz bilgileri, tarayıcı bilgisi, ziyaret edilen sayfalar<br />
            <b>Hizmet Kullanım Bilgileri:</b> Müşteri hizmetleriyle yapılan görüşmeler, destek talepleri
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>III. Kişisel Verilerin Kullanım Amaçları</h3>
            Motopack, topladığı kişisel verileri aşağıdaki amaçlarla kullanabilir:<br />
            <b>Hizmet Sağlama:</b> Sunmuş olduğumuz hizmetlerin ve ürünlerin sağlanması, yönetilmesi ve desteklenmesi.<br />
            <b>İletişim:</b> Hizmetlerimiz hakkında bilgi sağlama, güncellemeler veya müşteri geri bildirimleri almak.<br />
            <b>Pazarlama ve İletişim:</b> İlgili kişilere özel teklifler, kampanyalar, reklamlar ve duyurular göndermek.<br />
            <b>Yasal Yükümlülükler:</b> Yasal yükümlülüklerin yerine getirilmesi ve düzenleyici kurumlarla gerekli iletişimin sağlanması.<br />
            <b>Hizmet İyileştirme:</b> Web sitemizin ve dijital platformlarımızın performansını artırmak, kullanıcı deneyimini geliştirmek.<br />
            <b>Güvenlik:</b> Web sitemizin ve dijital platformlarımızın güvenliğini sağlamak, kötüye kullanım ve dolandırıcılık gibi durumları önlemek.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>IV. Kişisel Verilerin Paylaşılması</h3>
            Motopack, kişisel verilerinizi üçüncü şahıslarla yalnızca aşağıdaki durumlarda paylaşabilir:<br />
            <b>Yasal Zorunluluklar:</b> Yasal zorunluluklar gereği, hukuki süreçler veya düzenleyici kurumların talepleri doğrultusunda.<br />
            <b>Hizmet Sağlayıcılar:</b> Motopack'in faaliyetlerini destekleyen üçüncü taraf hizmet sağlayıcılarıyla, yalnızca ilgili hizmetin yerine getirilmesi amacıyla.<br />
            <b>İş Ortakları:</b> Belirli bir ürün veya hizmetin sağlanması için iş ortaklarıyla verilerinizi paylaşabiliriz, ancak bu paylaşımlar yalnızca söz konusu hizmetle sınırlıdır.<br />
            <b>Yatırımcılar ve Denetçiler:</b> Şirketin finansal denetimi ve raporlaması için gerek duyulan durumlarda, gizlilik yükümlülüklerine uymak koşuluyla.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>V. Kişisel Verilerin Saklanması ve Güvenliği</h3>
            Motopack, kişisel verilerin güvenliğini sağlamak için uygun teknik ve idari tedbirleri almaktadır. Veriler, yalnızca belirli bir süre için saklanacak ve bu süre sonunda güvenli bir şekilde silinecektir.<br />
            Verilerin saklanma süresi, ilgili hizmetin sağlanması veya yasal yükümlülüklerin yerine getirilmesi için gerekli süreyle sınırlıdır.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VI. Çerezler (Cookies)</h3>
            Web sitemizde çerezler kullanılmaktadır. Çerezler, web sitemizin kullanımını izlemek ve kullanıcı deneyimini geliştirmek amacıyla kullanılan küçük metin dosyalarıdır. Çerezleri, web sitemizi ziyaret ettiğinizde kabul edebilirsiniz. Çerezler hakkında daha fazla bilgi edinmek için web sitemizdeki Çerez Politikası'na göz atabilirsiniz.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VII. Kullanıcı Hakları</h3>
            Kişisel verilerinizle ilgili olarak aşağıdaki haklara sahipsiniz:<br />
            <b>Veri Erişim Hakkı:</b> Hangi kişisel verilerinizin işlendiğini öğrenme hakkı.<br />
            <b>Veri Düzeltme Hakkı:</b> Eksik veya yanlış işlenmiş verilerinizin düzeltilmesini talep etme hakkı.<br />
            <b>Veri Silme Hakkı:</b> Kişisel verilerinizin silinmesini veya yok edilmesini talep etme hakkı.<br />
            <b>İşleme İtirazı:</b> Kişisel verilerinizin işlenmesine itiraz etme hakkı.<br />
            <b>Veri Taşınabilirliği:</b> Verilerinizi başka bir veri sorumlusuna aktarma hakkı.<br />
            Bu haklarınızı kullanmak için, lütfen bizimle iletişime geçin.
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>VIII. İletişim Bilgileri</h3>
            Motopack ile ilgili gizlilik politikası hakkında sorularınız veya endişeleriniz varsa, aşağıdaki iletişim kanallarını kullanarak bizimle iletişime geçebilirsiniz:<br />
            <b>E-posta:</b> info@motopack.com.tr<br />
            <b>Adres:</b> Güzeloluk Mah. 1830 Sk. No:202/B Florya S. Muratpaşa / ANTALYA
            <h3 style={{ fontWeight: 600, color: 'var(--primary-color)', marginTop: '1.5rem', marginBottom: '0.5rem' }}>IX. Politikanın Yürürlüğü ve Güncellenmesi</h3>
            Motopack, bu Gizlilik Politikasını zaman zaman güncelleyebilir. Yapılacak herhangi bir değişiklik, web sitemizde yayınlandığı tarihte geçerlilik kazanacaktır. Politikada yapılan önemli değişiklikler kullanıcılarımıza bildirilir.
          </div>
        </div>
      </section>
      {/* Yardım Kartı */}
      <section className="help-section" style={{ background: 'transparent', padding: 0, margin: 0 }}>
        <div className="container" style={{ maxWidth: 1200, margin: '0 auto', padding: '0 1.5rem' }}>
          <div style={{
            background: 'var(--primary-lightest)',
            borderRadius: '12px',
            padding: '1.1rem 1.2rem',
            margin: '2.2rem 0 1.2rem 0',
            color: 'var(--primary-dark)',
            fontWeight: 500,
            fontSize: '1.05rem',
            boxShadow: '0 2px 8px 0 rgba(0,102,204,0.07)',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: '1.2rem',
            position: 'relative',
            minHeight: 110,
            flexWrap: 'wrap',
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
              <div style={{ fontWeight: 700, fontSize: '1.18rem', marginBottom: 6 }}>Herhangi Bir Yardım İhtiyacınız Var mı?</div>
              <div style={{ fontSize: '1.02rem', color: 'var(--primary-dark)', opacity: 0.92 }}>Merak ettiğiniz her konuda, şikayet ve önerilerinizle ilgili olarak bizimle iletişime geçebilirsiniz.</div>
            </div>
            <div style={{ marginLeft: 'auto', alignSelf: 'flex-end' }}>
              <Link to="/iletisim" style={{
                display: 'inline-block',
                background: 'linear-gradient(90deg, var(--primary-color) 0%, var(--primary-light) 100%)',
                color: '#fff',
                fontWeight: 700,
                fontSize: '1rem',
                borderRadius: 8,
                padding: '0.72rem 1.7rem',
                textDecoration: 'none',
                boxShadow: '0 2px 8px 0 rgba(0,102,204,0.09)',
                transition: 'background 0.18s, box-shadow 0.18s',
                position: 'relative',
                bottom: 0,
                right: 0,
                marginTop: 12,
              }}>Bize Yazın</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GizlilikPolitikasi; 